import circleSolid from '../media/chart/CircleSolid.svg';
import circleDotted from '../media/chart/CircleDotted.svg';
import diamondSolid from '../media/chart/DiamondSolid.svg';
import diamondDotted from '../media/chart/DiamondDotted.svg';
import triangleDownSolid from '../media/chart/TriangleDownSolid.svg';
import triangleDownDotted from '../media/chart/TriangleDownDotted.svg';
import triangleUpSolid from '../media/chart/TriangleUpSolid.svg';
import triangleUpDotted from '../media/chart/TriangleUpDotted.svg';

export const getPerformanceCardStyle = palette => ({
  '.performance-card': {
    display: 'flex',
    flexDirection: 'column',
    '& .performance-card-metrics-picker': {
      display: 'flex',

      '& .metric-picker__text': {
        flex: '0 1 auto',
        minWidth: 1,

        '&:hover': {
          background: palette.neutralLighter,
        },
      },
      '& .performance-card-metrics-picker__metric': {
        display: 'flex',
        flex: '0 1 auto',
        minWidth: 1,
        padding: '16px 25px 27px 0px',
        alignItems: 'center',

        '& > div': {
          flex: '1 1 auto',
          minWidth: 1,
          display: 'flex',

          '& .metric-picker': {
            borderStyle: 'solid',
            borderColor: 'transparent',
            justifyContent: 'center',
            padding: '0px',
            height: '40px',
            minWidth: '60px',
            alignItems: 'flex-start',

            '&:hover': {
              background: 'transparent',
            },
          },
        },

        '& .marker': {
          backgroundRepeat: 'no-repeat',
          width: 14,
          height: 40,
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          flex: 'none',
        },
      },

      '& .performance-card-metrics-picker__metric--column0': {
        '& .original-marker': {
          backgroundImage: `url("${circleSolid}")`,
        },
        '& .comparison-marker': {
          backgroundImage: `url("${circleDotted}")`,
        },
      },
      '& .performance-card-metrics-picker__metric--column1': {
        '& .original-marker': {
          backgroundImage: `url("${diamondSolid}")`,
        },
        '& .comparison-marker': {
          backgroundImage: `url("${diamondDotted}")`,
        },
      },
      '& .performance-card-metrics-picker__metric--column2': {
        '& .original-marker': {
          backgroundImage: `url("${triangleDownSolid}")`,
        },
        '& .comparison-marker': {
          backgroundImage: `url("${triangleDownDotted}")`,
        },
      },
      '& .performance-card-metrics-picker__metric--column3': {
        paddingRight: 0,
        '& .original-marker': {
          backgroundImage: `url("${triangleUpSolid}")`,
        },
        '& .comparison-marker': {
          backgroundImage: `url("${triangleUpDotted}")`,
        },
      },
      '& .metric-picker .metric-picker__button.metric-picker__button--caret.dropdown-toggle.btn.btn-default': {
        height: 'auto',
      },
    },
  },
});
